<template>
  <div style="display:none;">
    <div id="printMe">
      <div class="overlay"></div>
      <div
        v-for="product in productInfos"
        v-bind:key="product.id"
        class="printArea"
        style="width : 150mm;  height: 100mm; margin:auto; text-align:center; align-items: center; justify-content: center;"
      >
        <div v-if="product.distinguish != 'distinguish'">
          <div class="img-wrap">
            <div class="text">
              {{ product.authCode }}
            </div>

            <div class="print_qr_code">
              <qrcode-vue :value="product.url" level="H" :renderAs="renderAs" :size="QrCodeSize"></qrcode-vue>
            </div>
            <img class="blur" :src="imageURL" width="585" height="375" />
          </div>
        </div>
        <div v-else>
          <table>
            <p
              style="margin:0px; padding:0px; width : 150mm; padding-right:2mm; padding-left:2mm; padding-top:5mm; padding-bottom:2mm; text-align: left;"
            >
              인쇄매수 : {{ product.variantPrintCount }} ▲
            </p>
            <div style="width : 150mm;">
              <p
                style="margin:0px; padding:0px; width : 150mm; padding-top:2mm; padding-left:2mm; padding-right:2mm; font-size: 11px; text-align: left; overflow: hidden; text-overflow: ellipsis;display:-webkit-box; -webkit-line-clamp:2;-webkit-box-orient:vertical;"
              >
                {{ product.productName }}
              </p>
              <p
                style="margin:0px; padding:0px; width : 150mm;  padding-left:2mm; padding-right:2mm; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; text-align: left;"
              >
                옵션 : {{ product.variantName }}
              </p>
              <p style="margin:0px; padding:0px; width : 150mm;  padding-left:2mm; padding-right:2mm; font-size: 11px; text-align: left;">
                상품코드 : {{ product.productCode }}
              </p>
              <p
                style="margin:0px; padding:0px; width : 150mm;  padding-bottom:2mm; padding-left:2mm;  padding-right:2mm; font-size: 11px; text-align: left;"
              >
                품목코드 : {{ product.variantCode }}
              </p>
            </div>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.img-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  margin-top: 10px;
}

.sticky {
  position: sticky;
  top: 0;
}

.blur {
  /*
  filter: brightness(50%);
  z-index: 1;
  */
}

.text {
  position: absolute;
  width: 65%;
  height: 132%;
  font-size: 20px;
  color: black;
  font-weight: 600;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.print_qr_code {
  position: absolute;
  right: 12.5%;
  top: 56.5%;
  font-size: 30px;
  color: black;
  font-weight: 600;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
</style>

<script>
import M from "@/libs/mapping.js";
import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import VueHtmlToPaper from "vue-html-to-paper";
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../../store";
import freshband_kr_img from "@/assets/authservice/custom_print_images/boohgle_auth_print_image.jpg";
import freshband_jp_img from "@/assets/authservice/custom_print_images/boohgle_auth_print_image_jp.jpg";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=no", "scrollbars=yes"],
  styles: ["/style/CustomLabelFreshBandType3.css"],
};

Vue.use(VueHtmlToPaper);

export default {
  data() {
    return {
      productInfos: [],
      QrCodeValue: "https://" + store.state.mallId + ".cafe24.com",
      QrCodeSize: "80",
      renderAs: "svg",
      tableDatas: [],
      listCount: 0,
      imageURL: null,
    };
  },
  components: {
    QrcodeVue,
  },
  mixins: [CommonMixin],
  methods: {
    btnOnClick: function() {
      this.tableDatas.push({
        itemname: "item",
        quantity: 1,
        sellingprice: 55,
        amount: 55,
      });
    },
    qrPrint: async function() {
      await this.$htmlToPaper("printMe", options);
    },
    qrCodePringttingContents: async function(data) {
      let idx = 0;
      this.productInfos = [];
      let _url = "https://" + store.state.mallId + ".cafe24.com/registration/index.html";
      if (sessionStorage.getItem(`${this.$store.state.mallId}_domain`)) {
        _url = "https://" + sessionStorage.getItem(`${this.$store.state.mallId}_domain`) + "/registration/index.html";
      }
      for (var productCode in data) {
        for (var variantCode in data[productCode]) {
          let distinguishData = {
            distinguish: "distinguish",
            productName: data[productCode][variantCode][0][0].product_name.replace(/<[^>]+>/g, ""),
            variantName: data[productCode][variantCode][0][0].variant_name,
            productCode: productCode,
            variantCode: variantCode,
            variantPrintCount: 0,
          };

          for (var i = 0; i < data[productCode][variantCode].length; i++) {
            for (var j = 0; j < data[productCode][variantCode][i][0].print_count; j++) {
              let serialNumber = data[productCode][variantCode][i][0].serial_number;
              let encrySerialNumber = btoa(encodeURI(data[productCode][variantCode][i][0].serial_number));

              let qrcode_url = _url + "?authQrCode=" + encrySerialNumber;
              /*
              const mall_id = this.$store.state.mallId;
              const shop_no = localStorage.getItem(
                `${this.$store.state.mallId}_shop_no`
              );
              if (mall_id == "freshband" && shop_no == "3") {
                qrcode_url =
                  "https://m.boohgle.co.kr/royalty.html?authQrCode=" +
                  encrySerialNumber;
              }
                  */

              let QrData = {
                id: this.listCount,
                url: qrcode_url,
                authCode: serialNumber,
              };
              this.productInfos.push(QrData);
              this.listCount++;
              if (!this.productInfos[idx].variantPrintCount) {
                this.productInfos[idx].variantPrintCount = 0;
              }
              distinguishData["variantPrintCount"]++;
            }
          }
          this.productInfos.push(distinguishData);
        }
      }
    },
    setQrPrintList: async function(data) {
      let getCount = Object.keys(data).length;
      if (!getCount) {
        alert("선택된 상품이 없습니다.");
        return false;
      }
      await this.qrCodePringttingContents(data);

      if (this.listCount == 0) {
        alert("인쇄수량이 없습니다.");
        return false;
      }
      this.qrPrint();
    },

    /*
    getBase64Image: async function (imgUrl, callback) {
      new Promise((resolve, reject) => {
        let img = new Image();

        img.onload = function () {
          let canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          let dataURL = canvas.toDataURL("image/png");

          callback(dataURL);
          resolve(callback(dataURL));
        };
        img.onerror = (error) => {
          reject(error);
        };
      });
    },
    */
    toDataUrl: async function(url) {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.onload = function() {
          let reader = new FileReader();
          reader.onloadend = async function() {
            resolve({
              image_url: reader.result,
            });
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
        xhr.onerror = reject;
      });
    },
    /*
    setDataUrl: async function (url) {
      this.dataURL = url;
    },
    */
    /**
     * QR 코드 인쇄 설정 정보 가져오기
     */
    getQrcodeSettingInfo: async function() {},
  },
  created: async function() {
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    this.eventHub.$on("setQrPrintList", this.setQrPrintList);
    const custom_check = M.isCustomCheck();
    console.log("custom check ", custom_check);
    if (custom_check === "freshband_kr") {
      this.imageURL = freshband_kr_img;
    } else if (custom_check === "freshband_jp") {
      this.imageURL = freshband_jp_img;
    }

    /*
    let result = await this.toDataUrl(
      "/authservice/etc/userfront/src/img/boohgle_auth_print_image.JPG"
    );
    this.setDataUrl(result.image_url);
    */
  },
};
</script>
